import {
	AMERICAN_EXPRESS,
	VISA,
	MASTER_CARD,
	DISCOVER,
} from "../constants";

const isAmericanExpress = (cardNumber) => /^3/.test(cardNumber);
const isVisa = (cardNumber) => /^4/.test(cardNumber);
const isMasterCard = (cardNumber) => /^5/.test(cardNumber);
const isDiscover = (cardNumber) => /^6/.test(cardNumber);

export const getCreditCardTypeFromNumber = (cardNumber) => {
	if (isAmericanExpress(cardNumber)) {
		return AMERICAN_EXPRESS;
	}

	if (isVisa(cardNumber)) {
		return VISA;
	}

	if (isMasterCard(cardNumber)) {
		return MASTER_CARD;
	}

	if (isDiscover(cardNumber)) {
		return DISCOVER;
	}

	return null;
};



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/credit-card.js